import type { FC } from 'react';
import { useLockedBody } from 'usehooks-ts';
import type { IButtonProps } from '@/DesignSystem/Model/DataModel';
import LessonBlur from '@/Module/Lesson/Component/LessonDetail/LessonBlur';
import LessonSubscriptionBlur from '@/Module/Lesson/Component/LessonDetail/LessonSubscriptionBlur';
import { useAppSelector } from '@/Module/Store/Hook';
interface ILessonDetailPDFLimitationProps {
  isLoggedIn: boolean;
  hasAccessHandout?: boolean;
  hasAccessToExam?: boolean;
  type: 'exam' | 'handout';
  onLoginClick?: IButtonProps['onClick'];
}
const LessonDetailLimitation: FC<ILessonDetailPDFLimitationProps> = ({
  isLoggedIn,
  hasAccessHandout,
  type,
  onLoginClick,
  hasAccessToExam
}) => {
  const isActiveTab = useAppSelector(state => state.lessonSection.activeTabNumber === 2 || state.lessonSection.activeTabNumber === 3);
  useLockedBody(isActiveTab, 'root');
  return <>
      {!isLoggedIn && <LessonBlur onClick={onLoginClick} type="handout" />}
      {type === 'exam' ? isLoggedIn && !hasAccessToExam && <LessonSubscriptionBlur type="exam" /> : isLoggedIn && !hasAccessHandout && <LessonSubscriptionBlur type="handout" />}
    </>;
};
export default LessonDetailLimitation;